/* global angular */

angular
.module('gc.ui.focus',[])
.directive('focus', [
'$timeout',
function($timeout) {
  'use strict';
  return {
    link: function(scope, element, attrs) {
      if (attrs.focus !== 'false') {
        // Both synchronous and asynchronous:
        // iOS Safari doesn't like asynchronous focus
        // and the second one might still be needed in some cases
        element[0].focus();
        $timeout(function(){
          element[0].focus();
        }, 25);
      }
    }
  };
}]);
